import React, { useState } from 'react';
import { Button, Form, Input, InputNumber, Modal, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { api, errorText } from './shared';

/**
 * Изменение коэффициента периода: ввод значения и основания → подтверждение «с X на Y».
 */
const CoefficientEditor = ({ period, current, settings, onChanged, buttonText = 'Изменить' }) => {
    const [open, setOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [form] = Form.useForm();
    const min = Number(settings?.coefficient_min ?? 0.8);
    const max = Number(settings?.coefficient_max ?? 0.9);

    const save = async (values, confirm = false) => {
        setSaving(true);
        try {
            await api.post('/coefficients', { period, value: values.value, basis: values.basis, confirm });
            message.success(`Коэффициент на ${period} сохранён: ${values.value}`);
            setOpen(false);
            onChanged?.();
        } catch (error) {
            const data = error?.response?.data;
            if (error?.response?.status === 409 && data?.needConfirm) {
                Modal.confirm({
                    title: 'Изменение коэффициента',
                    content: data.error,
                    okText: 'Подтвердить',
                    cancelText: 'Отмена',
                    onOk: () => save(values, true)
                });
            } else {
                message.error(errorText(error));
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Button
                size="small"
                icon={<EditOutlined />}
                onClick={() => {
                    form.setFieldsValue({ value: current, basis: '' });
                    setOpen(true);
                }}
            >
                {buttonText}
            </Button>
            <Modal
                open={open}
                title={`Коэффициент на ${period}`}
                okText="Сохранить"
                confirmLoading={saving}
                onCancel={() => setOpen(false)}
                onOk={() => form.validateFields().then(v => save(v))}
                destroyOnClose
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="value"
                        label={`Коэффициент (допустимо ${min}–${max})`}
                        rules={[{ required: true, message: 'Укажите коэффициент' }]}
                    >
                        <InputNumber min={min} max={max} step={0.01} precision={4} style={{ width: 160 }} />
                    </Form.Item>
                    <Form.Item name="basis" label="Основание изменения" rules={[{ required: true, message: 'Укажите основание' }]}>
                        <Input.TextArea rows={2} placeholder="Например: допсоглашение №3 от 01.09.2026" />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default CoefficientEditor;
